import { Component, OnInit, Injectable } from '@angular/core';
import { OfficeService } from '../../shared/_services/office.service'
import { UserService } from '../../shared/_services/user.service'
import { OfficeManagement, UserManagement } from '../../shared/models/management.model'
import { User } from '../../shared/models/user.model';
import { Resolve } from '@angular/router';
import { concat } from 'rxjs/operators';
@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.css']
})
export class ManagementComponent implements OnInit {

  ListUser: UserManagement[];
  ListOffice: OfficeManagement[]
  error: any;
  complete = false;
  success: string;

  constructor(
    private _officeService: OfficeService ,
    private _userService: UserService
   ) { }

  ngOnInit() {
    
    this._officeService.getOfficeManagement()
      .subscribe(result => {
        this.ListOffice = result;
        this._userService.getUserManagement()
          .subscribe(users => {
            this.ListUser = users;
            this.ListUser.forEach(x => x.idsucursales = [])
          }, err => {
            this.error = err;
            this.cleanError();
          })
      }, err => {
        this.error = err;
        this.cleanError();
      });
  }
  
  asignarsucursal(idoffice: number, iduser: number, check: any) {
    //Borra sucursal de otros user 
    this.ListUser.forEach(user => {
      var indice = user.idsucursales.indexOf(idoffice,0);
      if (indice != -1)
      user.idsucursales.splice(indice, 1);
    });
    //Agrega Nueva Sucursa a user
    this.ListUser.some(user => {
      if (user.idUser == iduser) {
        user.idsucursales.push(idoffice);       
        return true;
      }
      return false;
    });
    //Vuelve reditribulle la suma de carteras

    this.ListUser.forEach(user => {
      user.portfolioCount = this.ListOffice
        .filter(function (e) { return user.idsucursales.includes(e.idOffice) })
        .reduce((sum, current) => sum + current.portfolioCount, 0);
    })

    //validar que todos los usuarios tengan sucursales

    this.complete = !this.ListUser.some(u => u.idsucursales.length < 1)

  }

  guardar() {
    if (this.complete) {
      this._officeService.saveOfficeManagement(this.ListUser)
        .subscribe((res: any) => {
          this.success = res.message;
        }, err => {
            this.error = err;
            this.cleanError();
        });
    } 
    
  }

  cleanError() {
    setTimeout(() => {
      this.error = "";
    }, 7000);
  }

}

@Injectable()
export class ManagementComponentResolve implements Resolve<any> {

  ListUser: UserManagement[];
  ListOffice: OfficeManagement[]
  error: any;

  constructor(
    private _officeService: OfficeService,
    private _userService: UserService
  ) {
  
  }

  resolve() {
    //Carga la lista de Estados de Usuario
    // Carga y Retirna la lista de Usuarios
    return null
  }

}
